
export default {
  name: 'AppButton',
  props: {
    block: { type: Boolean, default: false },
    variant: {
      type: String,
      default: 'basic',
      validator: v =>
        [
          'basic',
          'outline',
          'outline-gray',
          'text-plain',
          'text-underline'
        ].includes(v)
    },
    label: { type: String, default: null },
    disabled: { type: Boolean, default: false }
  }
};
